import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import reportWebVitals from './reportWebVitals';
import { MainApp } from './MainApp';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import "./css/main.css"
ReactDOM.render(
    <Provider store={configureStore({})}>
        <StrictMode>
            <MainApp />
        </StrictMode>
    </Provider>,
    document.getElementById('root')
);
reportWebVitals();
